import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { InstallPages } from '../install-pages';
import { type Manifest, PAGE_TYPE } from '@/types/manifest';

@injectable()
export class InstallPagesImpl implements InstallPages {
    public getManifests() {
        const modules = import.meta.glob('@/presentation/pages/**/manifest.ts', { eager: true });
        let manifests: Manifest[] = [];

        for (const path in modules) {
            const mod: any = modules[path];
            manifests.push(mod.manifest);
        }

        manifests = manifests.sort((before, after) => {
            return (before.tabIndex || 0) - (after.tabIndex || 0);
        });

        return manifests;
    }

    public getToolManifests() {
        return this.getManifests().filter(manifest => manifest.type === PAGE_TYPE.TOOL);
    }

    public getPageManifests() {
        return this.getManifests().filter(manifest => manifest.type === PAGE_TYPE.PAGE);
    }

    public getEntryManifest() {
        const manifests = this.getManifests();
        return manifests.find(manifest => manifest.type === PAGE_TYPE.ENTRY) || manifests[0];
    }
}
